import React from "react";
import { Snackbar, SnackbarContent } from "@material-ui/core";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { selectSnackbarOpen } from "./selectors";
import { setSnackbarOpen } from "./actions";

class PostStatusSnackbar extends React.Component {
    render() {
        const { snackbarOpen } = this.props;
        let message;
        let color;
        if (snackbarOpen.status === true) {
            color = "green";
            message = "Update Jobpack Status";
        } else {
            color = "red";
            message =
                "Unable to update Jobpack Status, Please Contact System Admin With Jobpack Details";
        }
        return (
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                autoHideDuration={4000}
                open={snackbarOpen.value}
                onClose={() => {
                    this.props.setSnackbarOpen(false, false);
                }}
            >
                <SnackbarContent
                    style={{
                        backgroundColor: color,
                        color: "white"
                    }}
                    message={message}
                />
            </Snackbar>
        );
    }
}

export default hot(module)(
    connect(
        store => {
            return {
                snackbarOpen: selectSnackbarOpen(store)
            };
        },
        { setSnackbarOpen }
    )(PostStatusSnackbar)
);
